import {ErrorMessage, Field, Form, Formik} from "formik";
import React, {useEffect, useState} from "react";
import styles from "../../styles/list_styles.module.scss";
import Button from "../../components/Button/Button";

import {ReactComponent as Download} from "../../assets/icons/download.svg";
import {ReactComponent as ArrowDown} from "../../assets/icons/arrow-down.svg";
import {ReactComponent as Lines} from "../../assets/icons/three_line_horizontal.svg";

import {BarLoader} from "react-spinners";
import {getOrders, serializeArray, updateStatus} from "../../services/services";
import Pagination from "../../components/Pagination/Pagination";
import {useMutation, useQuery} from "react-query";
import {getToken} from "../../services/auth";
import {IGetOrders, IOrdersResponse, IOrderItem, IPostUpdateStatus} from "../../ts/interfaces/Order/interface";
import Checkbox from "@mui/material/Checkbox";
import Select2 from "react-select";
import {stylesSelect} from "../../helper/stylesSelect";
import ProductsModal from "../../components/ProductsModal/ProductsModal";
import ModalConfirm from "../../components/ModalConfirm/ModalConfirm";
import {queryClient} from "../../services/queryClient";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";

const Orders: React.FC = () => {
    document.title = 'Admin - Pedidos';

    const [filter, setFilter] = useState<IGetOrders>({
        id: null,
        name: null,
        email: null,
        status: null,
        init_date: null,
        final_date: null,
        page: 1,
        limit: 50,
    });

    const [selectFilters, setSelectFilters] = useState({
        status: ""
    });

    const [action, setAction] = useState<string | null>(null);
    const [openActionModal, setOpenActionModal] = useState<boolean>(false);

    const [selectedProducts, setSelectedProducts] = useState<IOrderItem[] | null>(null)

    const [open, setOpen] = useState(false);
    const [selectedIds, setSelectedIds] = useState<number[]>([]);

    const navigate = useNavigate();

    const {data, isLoading} = useQuery<IOrdersResponse>(
        ["orders", filter],
        () => getOrders(filter),
        {
            staleTime: Infinity,
        }
    );

    useEffect(() => {
        setAction(null)
    }, [selectedIds]);

    useEffect(() => {
        if (action === 'print_labels_for_shipping') {
            handleDownloadShippingLable()
        }

    }, [action]);

    const handleDownloadCSV = () => {
        let link = document.getElementById("download_csv");
        link?.click();
    };

    const handleDownloadShippingLable = () => {
        let link = document.getElementById("download_shipping_labels");
        link?.click();
    };

    const addOrRemoveOrderId = (id: number) => {
        let selectedIdsCopy = selectedIds.slice();
        let index = selectedIdsCopy.indexOf(id);

        if (index === -1) {
            selectedIdsCopy.push(id);
        } else {
            selectedIdsCopy.splice(index, 1);
        }

        setSelectedIds(selectedIdsCopy);
    }

    const addOrRemoveAllOrderId = () => {
        if (data) {
            let selectedIdsCopy = selectedIds.slice();
            if (selectedIdsCopy.length === data.data.orders.length) {
                selectedIdsCopy = [];
            } else {
                selectedIdsCopy = data.data.orders.map(item => item.id);
            }

            setSelectedIds(selectedIdsCopy);
        }
    }

    const getActionMessage = () => {
        switch (action) {
            case "mark_payments_as_received":
                return "Tem certeza que deseja marcar os pagamentos dos pedidos selecionados como recebidos?";
            case "mark_as_packed":
                return "Tem certeza que deseja marcar os pedidos selecionados como embalados?";
            case "notify_shipments":
                return "Tem certeza que deseja notificar os envios dos pedidos selecionados?";
            case "cancel_orders":
                return "Tem certeza que deseja cancelar os pedidos selecionados?";
            default:
                return null;
        }
    };

    const UpdateStatusMutation = useMutation((data: IPostUpdateStatus) => {
        return updateStatus(data);
    }, {
        onSettled: (data) => {
            if (data?.data?.success) {
                queryClient.invalidateQueries(["orders", filter]);
                toast.success("Status atualizado com sucesso");
            } else {
                toast.error("Erro ao atualizar status. " + data?.data?.msg);
            }
            setOpenActionModal(false);
        },
        onError: () => {
            toast.error("Erro ao atualizar status.");
        },
    })

    const getActionFunction = () => {

        switch (action) {
            case "mark_payments_as_received":
                return UpdateStatusMutation.mutate({
                    ids: selectedIds,
                    status: 'paid'
                });
            case "mark_as_packed":
                return UpdateStatusMutation.mutate({
                    ids: selectedIds,
                    status: 'waiting_for_carrier'
                });
            case "notify_shipments":
                return () => {
                };
            case "cancel_orders":
                return UpdateStatusMutation.mutate({
                    ids: selectedIds,
                    status: 'cancelled'
                });
            default:
                return () => {
                };
        }
    }

    return (
        <div className={styles.container}>
            <h1>Pedidos</h1>

            <Formik
                initialValues={{
                    id: "",
                    name: "",
                    email: "",
                }}
                onSubmit={(values) => {
                    setFilter({
                        ...filter,
                        id: values.id && values.id !== '' ? parseInt(values.id) : null,
                        name: values.name,
                        email: values.email,
                        status: selectFilters.status,
                        page: 1,
                    });
                }}
            >
                <Form className={styles.searchProducts}>
                    <div className={styles.alignInput}>
                        <Field
                            name="id"
                            type="text"
                            placeholder="Pesquisar por ID"
                            className={styles.input}
                            disabled={isLoading}
                        />
                        <ErrorMessage
                            name="id"
                            component="div"
                            className={styles.error}
                        />

                        <Field
                            name="name"
                            type="text"
                            placeholder="Pesquisar por nome"
                            className={styles.input}
                            disabled={isLoading}
                        />
                        <ErrorMessage
                            name="name"
                            component="div"
                            className={styles.error}
                        />

                        <Field
                            name="email"
                            type="text"
                            placeholder="Pesquisar por email"
                            className={styles.input}
                            disabled={isLoading}
                        />
                        <ErrorMessage
                            name="email"
                            component="div"
                            className={styles.error}
                        />

                        <div className={styles.groupInput}>
                            <Select2
                                styles={stylesSelect}
                                options={[
                                    {value: "", label: "Selecione"},
                                    {value: "new", label: "Novo"},
                                    {value: "waiting_payment", label: "Aguardando Pagamento"},
                                    {value: "paid", label: "Pago"},
                                    {value: "in_separation", label: "Em Separação"},
                                    {value: "waiting_for_carrier", label: "Embalado"},
                                    {value: "in_transport", label: "Em Transporte"},
                                    {value: "delivered", label: "Entregue"},
                                    {value: "refunded", label: "Reembolsado"},
                                    {value: "cancelled", label: "Cancelado"},
                                ]}
                                onChange={(selectedOption) => {
                                    const selected = selectedOption?.value || "";
                                    setSelectFilters((prev) => ({...prev, status: selected.toString()}));

                                }}
                                placeholder="Pesquisar por Status"
                            />
                        </div>
                    </div>
                    <div className={styles.alignButtonSearch}>
                        <Button
                            type="submit"
                            width="115px"
                            height="39px"
                            theme="primary"
                            fontSize="14px"
                            disabled={isLoading}
                        >
                            Pesquisar
                        </Button>
                    </div>
                </Form>
            </Formik>

            <div className={styles.alignButtonCsvRegister}>
                <Button
                    width="115px"
                    height="39px"
                    theme="close"
                    icon={<Download/>}
                    fontSize="14px"
                    onClick={() => handleDownloadCSV()}
                    disabled={isLoading}
                >
                    CSV
                </Button>
            </div>
            <div className={styles.dNone}>
                <a
                    id="download_csv"
                    rel="noopener noreferrer"
                    href={
                        process.env.REACT_APP_API_URL +
                        "/admin/order/export?" +
                        serializeArray(filter) +
                        "&token=" +
                        getToken()
                    }
                    target="_blank"
                    download
                ></a>
                <a
                    id="download_shipping_labels"
                    rel="noopener noreferrer"
                    href={
                        process.env.REACT_APP_API_URL +
                        "/admin/order/shipping-labels?" +
                        serializeArray({ids: selectedIds}) +
                        "&token=" +
                        getToken()
                    }
                    target="_blank"
                    download
                ></a>
            </div>

            {selectedIds.length > 0 &&
                <div className={styles.actions}>
                    <Select2
                        styles={stylesSelect}
                        options={[
                            {value: "mark_payments_as_received", label: "Marcar pagamentos como recebidos"},
                            {value: "mark_as_packed", label: "Marcar como embalados"},
                            {value: "notify_shipments", label: "Notificar envios"},
                            {value: "print_labels_for_shipping", label: "Imprimir etiquetas para envio"},
                            {value: "print_content_declaration", label: "Imprimir declaração de conteúdo"},
                            {value: "cancel_orders", label: "Cancelar pedidos"},
                        ]}

                        onChange={(selectedOption) => {
                            const selected = selectedOption?.value || "";
                            setAction(selected.toString());
                            setOpenActionModal(true);
                        }}
                        placeholder="Escolha uma ação"
                    />
                </div>
            }

            <div className={styles.tableProducts}>
                {isLoading ? (
                    <div className={styles.alignCenter}>
                        <span>Carregando</span>
                        <BarLoader
                            color={"#2b6cded9"}
                            loading={isLoading}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </div>
                ) : (
                    <>
                        {data && data.data.orders.length > 0 ? (
                            <table>
                                <thead>
                                <tr>
                                    <th>
                                        <Checkbox
                                            sx={{
                                                color: "#FF9800",
                                                "&.Mui-checked": {
                                                    color: "#FF9800",
                                                },
                                            }}
                                            onChange={() => addOrRemoveAllOrderId()}
                                            checked={data.data.orders.length === selectedIds.length}
                                        />
                                    </th>
                                    <th>Pedido</th>
                                    <th>Data</th>
                                    <th>Cliente</th>
                                    <th>Total</th>
                                    <th>Status</th>
                                    <th>Produtos</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.data.orders.map(
                                    (order) => (
                                        <tr key={order.id}>
                                            <td>
                                                <Checkbox
                                                    sx={{
                                                        color: "#FF9800",
                                                        "&.Mui-checked": {
                                                            color: "#FF9800",
                                                        },
                                                    }}
                                                    checked={selectedIds.includes(order.id)}
                                                    onChange={() => addOrRemoveOrderId(order.id)}
                                                />
                                            </td>
                                            <td className={styles.incrementId}>#{order.increment_id}</td>
                                            <td>{order.created_at}</td>
                                            <td className={styles.customer}>
                                                <span>{order.name}</span>
                                                <span>{order.email}</span>
                                            </td>
                                            <td>{order.total}</td>
                                            <td>{order.status}</td>
                                            <td className={styles.products}
                                                onClick={() => {
                                                    setOpen(true);
                                                    setSelectedProducts(order.items);
                                                }}>Ver {order.items.length} <ArrowDown/>
                                            </td>
                                            <td>
                                                <button
                                                    className={
                                                        styles.editProducts
                                                    }
                                                    onClick={() => navigate('/order/progress/' + order.id)}
                                                >
                                                    <Lines/>
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                )}
                                </tbody>
                            </table>
                        ) : (
                            <div className={styles.alignCenter}>
                                <span>Nenhum registro encontrado.</span>
                            </div>
                        )}
                    </>
                )}
            </div>
            {data && (
                <Pagination
                    currentPage={data.data.currentPage}
                    lastPage={data.data.lastPage}
                    onPageChange={(payload: number) =>
                        setFilter({...filter, page: payload})
                    }
                />
            )}

            {open && selectedProducts && (
                <ProductsModal
                    open={open}
                    setOpen={setOpen}
                    setSelectedProducts={setSelectedProducts}
                    items={selectedProducts}
                />
            )}

            {openActionModal && action && getActionMessage() && (
                <ModalConfirm
                    propsFunction={getActionFunction}
                    open={openActionModal}
                    setOpen={setOpenActionModal}
                    loading={false}
                >
                    <span>{getActionMessage()}</span>
                </ModalConfirm>
            )}
        </div>
    );
};

export default Orders;
